module.exports = __webpack_public_path__ + "img/about_usat.83a3c120.png";